<template>
  <div  v-if="isDataReady && aoiObj?.bbox != null">
    <div class="map-flex-wrapper"  :style="{height: mapHeight + 'px', width: '100%'}" >
      <standard-map ref="map" :map-div-id="mapId" :map-config="mapOption.config"
        :map-layers="mapOption.mapLayers" :aoi-data="aoiObj"
        :height="550" :widthPct="widthPct"/>
    </div>
    <map-link :map-config="mapOption.mapLayers"/>
  </div>
  <div v-else>
    <div class="map-flex-wrapper"  :style="{height: mapHeight + 'px', width: '100%'}" >
      <spinning-icon/>
    </div>
  </div>
</template>

<script>
import { reactive, ref, computed } from 'vue';
import { useApp } from '@/composables/state/profileState';
import StandardMap from '@/components/map/StandardMap.vue'
import SpinningIcon from '@/components/map/SpinningIcon.vue'
import MapLinks from '@/components/map/MapLinks.vue';

export default {
  name: 'osr-hf-map',
  components: {
    'standard-map': StandardMap,
    'spinning-icon': SpinningIcon,
    'map-link': MapLinks
  },
  props: ['isOSR', 'widthPct', 'hfYear'],
  setup (props) {
    const { osrHFLayers, aoiData, aoiOSRData, currentTab } = useApp();
    const isDataReady = ref(false);
    const mapId = 'map' + Date.now();
    const mapOption = reactive({});
    const mapHeight = 550;
    const loadData = async () => {
      if (!isDataReady.value && osrHFLayers?.value?.length > 0) {
        const allLayerIds = osrHFLayers.value.reduce((prev, x) => [...prev, ...x.ids], []);
        Object.assign(mapOption, {
          config: { showLegend: true, mapCategory: 'mapCategory', allowHideLayer: true, showMapControl: true, excludeTextFromLegend: ' ' + props.hfYear },
          mapLayers: allLayerIds.map(x => { return { mapId: x, toShow: true, name: x.name, showInLegend: true }; })
        });
        isDataReady.value = true;
      }
    };

    const aoiObj = computed(() => {
      return (props.isOSR ? aoiOSRData : aoiData);
    });
    /*
      issue with watching array (tried deep, update contents, and replace objects), all didn't triger the watch.
      So for this case (array will be loaded only once, and will never be changed), I use the maplayer array size to check.
      TODO:  Still need to work out in general cases, how to watch array.
    */
    // watch(() => mapLayers.length, async (newVal, oldVal) => {
    //   if (newVal) {
    //     loadData();
    //   }
    // });

    return {
      mapId,
      aoiObj,
      isDataReady,
      mapOption,
      loadData,
      mapHeight,
      osrHFLayers,
      currentTab
    }
  },

  created () {
    this.loadData();
  },
  watch: {
    osrHFLayers: {
      handler (val, oldVal) {
        this.loadData();
      },
      deep: true
    },
    currentTab: {
      /* use this the refresh map, as the initally hidden maps don't have a proper size (although size were assigned, but on windows it was hidden so size was not right)
      */
      handler (val, oldVal) {
        this.$nextTick(function () {
          // Code that will run only after the
          // entire view has been re-rendered
          this.$refs.map && this.$refs.map.redraw();
        })
      }
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.map-flex-wrapper {
  display: flex;
  align-items: end;
  justify-content: space-between;
}
</style>
